import TWIABatchesLanding from './component/TWIABatchesLanding/TWIABatchesLanding.jsx';
import ReportComponent from './component/ReportComponent/ReportComponent.jsx';
import AddTransferRequest from './component/AddTransferRequest/AddTransferRequest.jsx';
import TransferRequestDetails from './component/TransferRequestDetails/TransferRequestDetails.jsx';
import TwiaCommissionLanding from './component/TwiaCommissionLanding/TwiaCommissionLanding.jsx';

const TWIABatchesComponentMap = {
    TWIABatchesLanding: { component: 'TWIABatchesLanding' },
    ReportComponent: { component: 'ReportComponent' },
    AddTransferRequest: { component: 'AddTransferRequest' },
    TransferRequestDetails: { component: 'TransferRequestDetails' },
    TwiaCommissionLanding: { component: 'TwiaCommissionLanding' },
};

const TWIABatchesComponent = {
    TWIABatchesLanding,
    ReportComponent,
    AddTransferRequest,
    TransferRequestDetails,
    TwiaCommissionLanding
};

export {
    TWIABatchesComponentMap,
    TWIABatchesComponent,
    TWIABatchesLanding,
    ReportComponent,
    AddTransferRequest,
    TransferRequestDetails,
    TwiaCommissionLanding
};
